import React, { useRef } from 'react'
import { useResizeObserver, useWindowSize } from 'usehooks-ts'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import Image from '@divvy-web/skylab.image'

import { MarketingPill } from '@sputnik/components/MarketingContent'
import useDeviceDetect from '@sputnik/hooks/useDeviceDetect'

import styles from './styles.module.scss'

// constant defined as the spacing between elements in the window that does
// not include the callout.
const restOfWindowSpacing = 155
// height of the 'Bill' logo
const billLogoHeight = 33.5
// the minimum height that the callout container must be in order for us to see
// its contents
const minCalloutHeight = 285

const SignInMarketingContent = () => {
  const [getClassName] = useNameFormatter('SignInMarketingContent')
  const { formatMessage } = useIntl()

  const imageRef = useRef(null)

  const { isMobile } = useDeviceDetect()
  const { height: windowHeight } = useWindowSize()
  const { height: imageHeight = 0 } = useResizeObserver({
    ref: imageRef,
    box: 'border-box',
  })

  const calloutHeight = windowHeight - imageHeight + billLogoHeight - restOfWindowSpacing

  return (
    <div className={styles[getClassName('')]}>
      <div ref={imageRef}>
        <Image
          alt={formatMessage({
            defaultMessage: 'person at computer',
            id: 'sputnik.SignInMarketingContent__Q/1ZGn',
          })}
          className={styles[getClassName('image')]}
          src='https://app.divvy.co/assets/stock-photos/credit-application-signin-marketing-content.png'
        />
      </div>
      <div
        className={styles[getClassName('callout')]}
        style={{
          ...(!isMobile && calloutHeight > minCalloutHeight && { height: `${calloutHeight}px` }),
        }}
      >
        <MarketingPill
          text={
            <FormattedMessage
              defaultMessage='Automate your finances'
              id='sputnik.SignInMarketingContent__QFe3LS'
            />
          }
        />
        <div className={styles[getClassName('callout-text')]}>
          <FormattedMessage
            defaultMessage='Streamline your business expenses'
            id='sputnik.SignInMarketingContent__rekfM7'
          />
        </div>
      </div>
    </div>
  )
}

export default SignInMarketingContent
